import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/Login.css';
import obraswiseLogo from '../assets/obraswise-logo.png';
import { apiService } from '../services/ApiService';
import { useTheme } from '../contexts/ThemeContext';
import { FiSun, FiMoon } from 'react-icons/fi';

const RecuperarSenha = ({ onBackToLogin }) => {
  const [loading, setLoading] = useState(false);
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const navigate = useNavigate();
  const { darkMode, toggleTheme } = useTheme();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess(false);
    setLoading(true);

    try {
      const result = await apiService.solicitarRecuperacaoSenha(email.toLowerCase().trim());

      if (result.success) {
        setSuccess(true);
      } else {
        setError(result.error || 'Ocorreu um erro ao solicitar a recuperação de senha.');
      }
    } catch (error) {
      setError('Ocorreu um erro ao conectar com o servidor. Tente novamente.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={`login-container ${!darkMode ? 'light-mode' : ''}`}>
      <div className="login-card">
        <div className="theme-toggle">
          <button 
            className="theme-button" 
            onClick={toggleTheme} 
            aria-label={darkMode ? "Mudar para tema claro" : "Mudar para tema escuro"}
          >
            {darkMode ? <FiSun /> : <FiMoon />}
          </button>
        </div>
        
        <div className="logo-container">
          <img src={obraswiseLogo} alt="Obraswise" className="logo" />
        </div>
        <h2 className="title">Recuperar Senha</h2>
        
        {success ? (
          <div className="success-message">
            <p>Um email foi enviado para {email} com instruções para redefinir sua senha.</p>
            <p>Por favor, verifique sua caixa de entrada e também a pasta de spam.</p>
            <button 
              type="button" 
              className="login-button" 
              onClick={onBackToLogin}
            >
              Voltar para Login
            </button>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="login-form">
            {error && <div className="error-message">{error}</div>}
            <div className="form-group">
              <label>Email</label>
              <input 
                type="email" 
                placeholder="Digite seu email cadastrado" 
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required 
                disabled={loading}
              />
              <small className="help-text">Digite o email que você usou para se cadastrar</small>
            </div>
            <button type="submit" className="login-button" disabled={loading}>
              Enviar Link de Recuperação
            </button>
            <button 
              type="button" 
              className="register-button" 
              onClick={onBackToLogin}
              disabled={loading}
            >
              Voltar para Login
            </button>
          </form>
        )}
        
        {loading && (
          <div className="loading-container">
            <div className="loading-spinner"></div>
            <p className="loading-text">Enviando email de recuperação...</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default RecuperarSenha; 